import API from '../../../api/api';

const API_URL = process.env.REACT_APP_BASE_API_URL;

// Get profile
const profile = async profileId => {
  const response = await API.get(`${API_URL}/api/v1/tag-info/tuid/${profileId}`);
  return response.data;
};

// exchange contact
const exchangeContact = async exchangeData => {
  const response = await API.post(
    '/api/v1/create_exchanged_info',
    exchangeData,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data.message;
};

// Profile functions
const profileServices = {
  profile,
  exchangeContact,
};

// Export
export default profileServices;
